<div [class.app-view]="isApp" style="height: calc(100%); width: 100%">
  <ng-container *ngIf="(selection$ | async) as selection">
    <ion-item *ngIf="isSelectionLocked(selection)" lines="none" color="warning">
      <ion-label class="ion-text-wrap">
        Deze lijst is afgesloten. Dieren toevoegen of verwijderen is niet meer mogelijk.
      </ion-label>
    </ion-item>
  </ng-container>
  <div class="animals-table-skeleton" *ngIf="loading || !uiReady">
    <ion-progress-bar type="indeterminate" color="primary"></ion-progress-bar>
    <div class="skeleton-header">
      <span class="skeleton-header-spacer"></span>
      <span class="col-werknr">{{ isApp ? 'Werknr.' : 'Levensnummer' }}</span>
      <span class="col-age">Leeftijd</span>
      <span class="col-gender">Geslacht</span>
      <span class="col-color">Kleur</span>
    </div>
    <div class="skeleton-body">
      <div
        class="skeleton-row"
        *ngFor="let i of skeletonRows"
        [class.skeleton-row-alt]="i % 2 === 1"
      >
        <span class="skeleton-mark"></span>
        <span class="skeleton-cell col-werknr"></span>
        <span class="skeleton-cell col-age"></span>
        <span class="skeleton-cell col-gender"></span>
        <span class="skeleton-cell col-color"></span>
      </div>
    </div>
    <div class="skeleton-footer">
      <span class="skeleton-cell skeleton-footer-text"></span>
    </div>
  </div>
  <ng-container *ngIf="!loading && uiReady">
    <ng-container *ngIf="(toolbarData$ | async) as toolbarCtx">
      <ion-toolbar *ngIf="toolbarCtx.colors" class="filter-toolbar">
        <div class="color-filter-dots" aria-label="Filter op kleur">
          <button
            type="button"
            class="color-dot color-dot-none"
            [class.selected]="(_filterByMarkColorValue$ | async) == null"
            (click)="setFilterByMarkColorValue(null)"
            [attr.aria-pressed]="(_filterByMarkColorValue$ | async) == null"
            title="Geen filter"
          >
            <span class="color-count">{{ getTotalSelectedCount(toolbarCtx.selection) }}</span>
          </button>
          <button
            *ngFor="let c of getUsedColors(toolbarCtx.colors)"
            type="button"
            class="color-dot"
            [style.background-color]="getMarkColorHex(c.value)"
            [class.selected]="(_filterByMarkColorValue$ | async) === c.value"
            (click)="setFilterByMarkColorValue(c.value)"
            [attr.aria-pressed]="(_filterByMarkColorValue$ | async) === c.value"
            [attr.title]="getColorFilterTitle(c)"
          >
            <span class="color-count">{{ getSelectedCountForColor(toolbarCtx.selection, c.value) }}</span>
          </button>
        </div>
      </ion-toolbar>
    </ng-container>
    <ng-container *subscribe="animals$ as animals">
      <ng-container *ngIf="(selection$ | async) as selection">
      <tcc-mono-data-table
        *ngIf="columns"
        [rowData]="animals"
        [columns]="columns"
        (onRowClicked)="animalSelected($event)"
        (onScroll)="loadMoreAnimals($event)"
        [displayFooter]="true"
        [totalNumberOfRows]="getTotalAnimalCount(selection)"
        [footerChange]="footerChange"
        [footerEndText]="getFooterWorkNumberText()"
        [minBufferPx]="scrollMinBufferPx"
        [maxBufferPx]="scrollMaxBufferPx"
        [useInfiniteScroll]="true"
        [loading]="loadingMore"
        [itemSize]="scrollItemSize"
        style="height: calc(100% - 70px);"
      ></tcc-mono-data-table>
      </ng-container>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="(selection$ | async) as selection">
    <ion-fab horizontal="center" vertical="bottom" mode="ios" *ngIf="!isSelectionLocked(selection)">
      <ion-fab-button (click)="addAnimal()">
        <fa-icon [icon]="['fal', 'plus-large']" size="xl"></fa-icon>
      </ion-fab-button>
    </ion-fab>
  </ng-container>
  <ion-fab horizontal="end" vertical="bottom" mode="ios" *ngIf="isApp">
    <ion-fab-button color="secondary" size="small">
      {{ currentCountryCode }}
    </ion-fab-button>
    <ion-fab-list side="top">
      <ion-fab-button (click)="currentCountryCode = 'DE'"> DE </ion-fab-button>
      <ion-fab-button (click)="currentCountryCode = 'BE'"> BE </ion-fab-button>
      <ion-fab-button (click)="currentCountryCode = 'DK'"> DK </ion-fab-button>
      <ion-fab-button (click)="currentCountryCode = 'NL'"> NL </ion-fab-button>
      <ion-fab-button (click)="currentCountryCode = 'FR'"> FR </ion-fab-button>
      <ion-fab-button (click)="currentCountryCode = 'IE'"> IE </ion-fab-button>
      <ion-fab-button (click)="currentCountryCode = 'LU'"> LU </ion-fab-button>
    </ion-fab-list>
  </ion-fab>
</div>

<ng-template #genderTmpl let-row="row" let-index="index">
  <ion-text
    [attr.data-gender-correct]="row.gender_correct === false ? 'false' : (row.gender_correct === true ? 'true' : null)"
    [attr.data-row-has-issue]="isApp && row.gender_correct === false ? 'true' : null"
    [attr.data-row-index]="index"
    style="display: flex; flex-direction: row; align-items: center; gap: 8px;"
  >
    <ion-text [color]="row.gender_id === 1 ? 'male' : 'female'">
      <fa-icon
        [icon]="['fal', row.gender_id === 1 ? 'mars' : 'venus']"
        size="lg"
      ></fa-icon>
    </ion-text>
    <ion-text color="danger" *ngIf="!isApp && row.gender_correct === false">
      <fa-icon
        [icon]="['fal', 'circle-xmark']"
        size="sm"
      ></fa-icon>
    </ion-text>
    <span *ngIf="!isApp && row.gender_correct !== false" style="width: 16px;"></span>
  </ion-text>
</ng-template>

<ng-template #colorTmpl let-row="row" let-index="index">
  <ion-text
    [attr.data-color-correct]="row.color_correct === false ? 'false' : (row.color_correct === true ? 'true' : null)"
    [attr.data-row-has-issue]="isApp && row.color_correct === false ? 'true' : null"
    [attr.data-row-index]="index"
    style="display: flex; flex-direction: row; align-items: center; justify-content: space-between; gap: 8px;"
  >
    <span>{{ row.color_name }}</span>
    <ion-text color="danger" *ngIf="!isApp && row.color_correct === false">
      <fa-icon
        [icon]="['fal', 'circle-xmark']"
        size="sm"
      ></fa-icon>
    </ion-text>
    <span *ngIf="!isApp && row.color_correct !== false" style="width: 16px;"></span>
  </ion-text>
</ng-template>

<ng-template #firstColWithIndicatorTmpl let-row="row" let-value="value">
  <div class="first-col-with-indicator">
    <div
      class="mark-color-indicator"
      [attr.data-mark-color]="row.selection_mark_color || null"
    ></div>
    <span class="first-col-value">{{ value }}</span>
  </div>
</ng-template>
